import React from 'react';

import styles from '../baners/Baner.module.css';
// import Baner from '../../images/car_1_2.jpg';



const baner = () => {
  return (
    <div className={styles.baner}>
      <div className={styles.baner_bg}>   
      
      <div >
      
      </div>

      {/* <div className={styles.baner_grid}> 
        <h2> <b>Get OUR BEST REATES </b> <small > <b>when you book at Avis.ge </b> </small></h2>
        <h3> <b>PLUS </b> <small > <b>save up to 10% when you pay in advance!</b></small></h3> 
        <button> SAVE NOW </button>
      </div >            */}
    </div>
    <div className={styles.baner_2}>
      
      <p className={styles.ppp}>
        SAVE up to 10% and get OUR BEST RATES! <span className={styles.span}>Book Now!</span>
      </p>
      
      
      </div>
    </div>
  ); 
}

export default baner;
